<div class="card">
  <app-header
    titulo="Processos executados"
    descricao="Listagem dos processos solicitados"
  ></app-header>

  <div class="flex flex-row flex-wrap">
    <div class="flex ml-1 xl:mt-1">
      <button icon="pi pi-plus" label="Nova Taxa" pButton (click)="abreTmaDialog(taxaSelecionada)"></button>
    </div>
    <div class="flex ml-1 xl:mt-1">
      <button icon="pi pi-download" label="Exportar" pButton (click)="exportar()"></button>
    </div>
  </div>

  <app-tmadialog [visivel]="visivel" [taxa]="taxaSelecionada" (fechar)="escondeTmaDialog()"></app-tmadialog>

  <div class="mt-3">
    <p-table [value]="taxas" dataKey="id" [loading]="loading" #dt
             [globalFilterFields]="['deEmpresa','dataInicial','dataFinal','taxa']"
             styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
             [rowsPerPageOptions]="[20, 50, 100, 1000, 10000]" [paginator]="true" [rows]="20"
             [showCurrentPageReport]="true"
             currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros">
      <ng-template pTemplate="caption">
        <div class="flex">
          <span class="p-input-icon-left ml-auto">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')"
                   placeholder="Pesquisar"/>
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>Empresa Erp
            <p-columnFilter field="deEmpresa" matchMode="in" display="menu" [showApplyButton]="false"
                            [showClearButton]="false" [showMatchModes]="false" [showOperator]="false"
                            [showAddButton]="false" style="width: 5rem;">

              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="empresas"
                               placeholder="Todos" [filter]="true" optionValue="id" (onChange)="filter($event.value)"
                               optionLabel="nome" emptyMessage="Sem registros">

                  <ng-template let-option pTemplate="item">
                    <span class="pr-8">{{ option.nome }}</span>
                  </ng-template>

                </p-multiSelect>
              </ng-template>
            </p-columnFilter>
          </th>
          <th>Data Inicial</th>
          <th>Data Final</th>
          <th>Valor</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-taxa>
        <tr>
          <td>{{ taxa.deEmpresa }}</td>
          <td>{{ taxa.dataInicial }}</td>
          <td>{{ taxa.dataFinal }}</td>
          <td>{{ taxa.taxa.toLocaleString("pt-br") }}</td>
          <td>

            <p-button icon="pi pi-pencil"
                      severity="primary"
                      class="m-2"
                      [rounded]="true"
                      [outlined]="true"
                      (click)="abreTmaDialog(taxa)">
            </p-button>

            <p-button
              icon="pi pi-trash"
              severity="danger"
              [rounded]="true"
              [outlined]="true"
              (onClick)="confirmarExclusao(taxa.id)"/>
          </td>

        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <td colspan="10">Nenhum registro encontrado</td>
      </ng-template>
    </p-table>
  </div>
  <p-confirmDialog [style]="{ width: '450px' }"/>
</div>
